import Page from "@lib/Page";

export default class Components extends Page {}



// WEBPACK FOOTER //
// ./scripts/pages/components.js